/**
 * 小工具集合
 *
 * @version 1.0.0
 *
 */
/**
 * 获取数据基本类型
 * @param val
 * @returns {string}
 */
import moment from 'moment'
import { UPLOAD_CDN_HOST } from '@/config/env'

export function getType(val) {
  return Object.prototype.toString.call(val).slice(8, -1)
}

/**
 * 是否是array
 * @param val
 * @returns {boolean}
 *
 * isArray([]) true
 * isArray(1) false
 */
export function isArray(val) {
  return getType(val) === 'Array'
}

/**
 * 是否是string
 * @param val
 * @returns {boolean}
 *
 * isString('1') true
 * isString(1) false
 */
export function isString(val) {
  return getType(val) === 'String'
}

/**
 * 是否是number
 * @param val
 * @returns {boolean}
 *
 * isString('1') false
 * isString(1) true
 */
export function isNumber(val) {
  return getType(val) === 'Number'
}

/**
 * 是否是空值
 * @param val
 * @returns {boolean}
 *
 * isEmpty() true
 * isEmpty(1) false
 */
export function isEmpty(val) {
  const type = getType(val)
  return type === 'Null' || type === 'Undefined' || val === ''
}

/**
 * 不是空值
 * @param val
 * @returns {boolean}
 *
 * isNotEmpty(1) true
 * isNotEmpty() false
 */
export function isNotEmpty(val) {
  const type = getType(val)
  return type !== 'Null' && type !== 'Undefined' && val !== ''
}

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 深拷贝
 * @param {Object} obj 拷贝对象
 */
export const deepCopy = (obj) => {
  let result = isArray(obj) ? [] : {}
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        result[key] = deepCopy(obj[key]) //递归复制
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

// 判断手机号是否是大陆格式
export const isMainlandPhoneNumber = (phoneNumber) => {
  const mainlandPhonePattern = /^1[3-9]\d{9}$/
  return mainlandPhonePattern.test(phoneNumber)
}

/* 函数节流 */
export const throttle = (fn, interval) => {
  let enterTime = 0 //触发的时间
  let gapTime = interval || 300 //间隔时间，如果interval不传，则默认300ms
  return function () {
    let context = this
    let backTime = new Date() //第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.apply(context, arguments)
      enterTime = backTime //赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  }
}

/* 函数防抖 */
export function debounce(fn, time = 1000, start = false) {
  let timer // 利用闭包函数 (存在内存中)
  return function () {
    const args = arguments
    if (start) {
      if (timer) clearTimeout(timer)
      // 重复点击清除定时器, 并重新开启计时
      else fn.apply(this, args)
      timer = setTimeout(() => {
        timer = null // 销毁 (从内存中释放)
      }, time)
    } else {
      clearTimeout(timer) // 重复点击清除定时器, 并重新开启计时
      timer = setTimeout(() => {
        fn.apply(this, args)
      }, time)
    }
  }
}

/**
 * 生成uuid
 * @returns {string}
 */
export const uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * 获取数组对象某一个值的数组集合
 * @param {Array} list
 * @param {String} key
 */
export const getKeyForList = (list, key = 'id') => {
  if (!isArray(list)) return []
  let result = []
  list.forEach((value) => {
    result.push(value[key])
  })
  return result
}

/**
 * 对比数组值是否相等
 * @param {Array} list
 * @param {String} key
 */
export const equals = (array1, array) => {
  // if the other array is a falsy value, return
  if (!array || !array1) return false
  // compare lengths - can save a lot of time
  if (array1.length != array.length) return false
  for (var i = 0, l = array1.length; i < l; i++) {
    // Check if we have nested arrays
    if (array1[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arraysif (!this[i].equals(array[i]))
      return false
    } else if (array1[i] != array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false
    }
  }
  return true
}
/**
 * 数组排序
 * @param arr 传入数组
 * @param k 移动后的位置
 * @param j 需要移动的位置
 */
export const sortArray = (arr, k, j) => {
  if (!isArray(arr)) {
    console.error('传入参数必须为数据')
    return []
  }
  if (k === j) return arr
  arr[k] = arr.splice(j, 1, arr[k])[0]
  return arr
}

/**
 * 数组去重
 * @param arr 传入数组
 * @returns {any[]}
 */
export const unique = (arr) => {
  if (!isArray(arr)) {
    console.error('传入参数必须为数组')
    return []
  }
  let list = new Set(arr)
  return [...list]
}

// 判断b数组是否都包含在a数组中
export const isContained = (a, b) => {
  if (!(a instanceof Array) || !(b instanceof Array)) return false

  if (a.length < b.length) return false // a的长度小于b 则b不可能包含在a中 所以返回false
  for (var i = 0, len = b.length; i < len; i++) {
    if (JSON.stringify(a).indexOf(JSON.stringify(b[i])) == -1) {
      // 只要b中有一个没有在a中存在，则说明a不可能完全包含b (selectArr, self.canAddList)
      return false
    }
  }
  return true
}

//数组对象的去重方法
export const uniqArrObj = (arrays, property) => {
  console.log('去重函数')
  var result = []

  var obj = {}
  for (var i = 0; i < arrays.length; i++) {
    if (!obj[arrays[i][property]]) {
      // 不存在

      result.push(arrays[i])

      obj[arrays[i][property]] = true
    }
  }
  console.log('去重后', result)
  return result
}

export const timeFormat = (params, startKey, endKey) => {
  /*if(params[startKey]==params[endKey]) {
    params[startKey] = params[startKey] + ' 00:00:00'
    params[endKey] = params[endKey] + ' 23:59:59'
  }*/
  params[startKey] = params[startKey] + ' 00:00:00'
  params[endKey] = params[endKey] + ' 23:59:59'
  return params
}

export const today = moment(new Date()).subtract(0, 'days').format('YYYY-MM-DD')

let todaytime = new Date().getTime()
let yesterdaytime = todaytime - 24 * 60 * 60 * 1000
let yesterdaytimeStart = new Date(yesterdaytime).setHours(0, 0, 0, 0)
let yesterdaytimeEnd = new Date(yesterdaytime).setHours(23, 59, 59, 999)

export const todayStartTime = moment(yesterdaytimeStart).format('YYYY-MM-DD HH:mm:ss')
export const todayEndTime = moment(yesterdaytimeEnd).format('YYYY-MM-DD HH:mm:ss')

// export const todayStartTime = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
// export const todayEndTime = moment(new Date()).subtract(0, 'days').format('YYYY-MM-DD HH:mm:ss')
export const thirtyDaysBefore = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD')
export const thirtyDaysBeforeTime = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss')
/**
 * @description 数字转中文
 * @param {Number|String}   num     数字[正整数]
 * @param {String}          type    文本类型，lower|upper，默认upper
 * @example number2text(100000000) => "壹亿元整"
 */
export const number2text = (number, type = 'upper') => {
  // 配置
  const confs = {
    lower: {
      num: ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
      unit: ['', '十', '百', '千', '万'],
      level: ['', '万', '亿'],
    },
    upper: {
      num: ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'],
      unit: ['', '拾', '佰', '仟'],
      level: ['', '万', '亿'],
    },
    decimal: {
      unit: ['分', '角'],
    },
    maxNumber: 999999999999.99,
  }
  // 过滤不合法参数
  if (Number(number) > confs.maxNumber) {
    console.error(`The maxNumber is ${confs.maxNumber}. ${number} is bigger than it!`)
    return false
  }
  let negativeNum = false
  if (Number(number) < 0) {
    negativeNum = true
    number = Math.abs(Number(number))
  }
  const conf = confs[type]
  const numbers = String(+number.toFixed(2)).split('.')
  const integer = numbers[0].split('')
  const decimal = Number(numbers[1]) === 0 ? [] : numbers[1]?.split('')

  console.log('decimal', numbers)
  // 四位分级
  const levels = integer.reverse().reduce((pre, item, idx) => {
    let level = pre[0] && pre[0].length < 4 ? pre[0] : []
    let value = item === '0' ? conf.num[item] : conf.num[item] + conf.unit[idx % 4]
    level.unshift(value)
    if (level.length === 1) {
      pre.unshift(level)
    } else {
      pre[0] = level
    }
    return pre
  }, [])
  // 整数部分
  const _integer = levels.reduce((pre, item, idx) => {
    let _level = conf.level[levels.length - idx - 1]
    let _item = item.join('').replace(/(零)\1+/g, '$1') // 连续多个零字的部分设置为单个零字
    // 如果这一级只有一个零字，则去掉这级
    if (_item === '零') {
      _item = ''
      _level = ''
      // 否则如果末尾为零字，则去掉这个零字
    } else if (_item[_item.length - 1] === '零') {
      _item = _item.slice(0, _item.length - 1)
    }
    return pre + _item + _level
  }, '')
  // 小数部分
  let _decimal = decimal
    ?.map((item, idx) => {
      const unit = confs.decimal.unit
      const _unit = item !== '0' ? unit[unit.length - idx - 1] : ''
      return `${conf.num[item]}${_unit}`
    })
    .join('')
  // 如果是整数，则补个整字
  return negativeNum ? `负${_integer}元` + (_decimal || '整') : `${_integer}元` + (_decimal || '整')
}

/**
 * 缩放图片
 * @param {String} img
 * @param {Number} w 缩放至多宽
 */
export const zoomImg = (img, w = 200) => {
  if (!img) return ''
  const src = img.startsWith('http') ? img : UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV] + img
  return `${src}?x-oss-process=image/resize,w_${w}/format,webp`
  // return src
}

/**
 * 精确加法
 * @param {Number} arg1 加数1
 * @param {Number} arg2 加数2
 * @returns {Number} 和
 */
export function add(arg1, arg2) {
  let r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

/**
 * 精确减法
 * @param {Number} arg1 被减数
 * @param {Number} arg2 减数
 * @returns {Number} 差
 */
export function subtract(arg1, arg2) {
  let r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

/**
 * 精确乘法
 * @param {Number} arg1 乘数1
 * @param {Number} arg2 乘数2
 * @returns {Number} 积
 */
export function multiply(arg1, arg2) {
  const s1 = arg1.toString()
  const s2 = arg2.toString()
  const m = (s1.split('.')[1] || '').length + (s2.split('.')[1] || '').length
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
}

/**
 * 精确除法
 * @param {Number} arg1 被除数
 * @param {Number} arg2 除数
 * @returns {Number} 商
 */
export function divide(arg1, arg2) {
  const t1 = (arg1.toString().split('.')[1] || '').length
  const t2 = (arg2.toString().split('.')[1] || '').length
  const r1 = Number(arg1.toString().replace('.', ''))
  const r2 = Number(arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}
// 金额处理
export const formatNumber = (val, decimalPlaces = 2) => {
  // 如果传入的值无效，返回0
  if (val == null || val === '' || isNaN(val)) {
    return '0'
  }

  const num = Number(val)

  // 如果是整数，直接返回
  if (num === parseInt(num, 10)) {
    return parseInt(num, 10).toString()
  }

  // 根据传入的参数确定保留几位小数，默认保留两位
  const rounded = num.toFixed(decimalPlaces)

  // 去除小数点最后的0
  return Number(rounded).toString()
}

export default {
  timeFix,
  deepCopy,
  throttle,
  debounce,
  isMainlandPhoneNumber,
  uuid,
  getKeyForList,
  isArray,
  isString,
  isNumber,
  getType,
  isEmpty,
  isNotEmpty,
  equals,
  sortArray,
  unique,
  isContained,
  uniqArrObj,
  timeFormat,
  number2text,
  today,
  todayEndTime,
  todayStartTime,
  thirtyDaysBefore,
  thirtyDaysBeforeTime,
  add,
  subtract,
  multiply,
  divide,
  formatNumber,
}
